import { render } from "./AttachmentType.vue?vue&type=template&id=4d52d7e5"
import script from "./AttachmentType.vue?vue&type=script&lang=js"
export * from "./AttachmentType.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__